var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.user.is_staff &&
    _setup.context.flavour === "full"
    ? _c(
        "a",
        {
          staticClass: "background-yellow text-body-2 pa-1",
          attrs: {
            target: "_blank",
            rel: "noopener noreferrer",
            href: _vm.link || "",
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }